<template>
  <div class="userCenter">
    <job-header-simple header_title="基本信息"></job-header-simple>
    <div class="card_box">
      <div class="card_header van-hairline--bottom">个人信息</div>
      <div class="card_content">
        <div class="baseInfo">
          <van-cell class="item item_head" title="头像">
            <van-image
              width="30px"
              height="30px"
              round
              fit="cover"
              :src="
                mobileDefaultAvatar
                  ? mobileDefaultAvatar
                  : userInfoData && userInfoData.headshot
                  ? userInfoData.headshot
                  : require('@/assets/img_default.png')
              "
            />
          </van-cell>
          <van-cell
            class="item"
            title="姓名"
            :value="userInfoData.name"
          ></van-cell>
          <van-cell
            class="item"
            title="手机号码"
            :value="userInfoData.mobile"
            is-link
            @click="resetTel"
          ></van-cell>
          <template v-for="item in papersTypeOptions">
            <van-cell
              class="item"
              title="证件类型"
              v-if="userInfoData.papersType == item.code"
              :value="item.value"
              :key="item.id"
            ></van-cell>
          </template>
          <van-cell
            class="item"
            title="证件号码"
            :value="userInfoData.idNumber | desensitization"
          ></van-cell>
          <van-cell class="item" title="证件照片">
            <template v-if="userInfoData.papersType == '1'">
              <span
                v-if="
                  userInfoData.front != null &&
                    userInfoData.front != 'undefined' &&
                    userInfoData.front != '' &&
                    userInfoData.back != null &&
                    userInfoData.back != 'undefined' &&
                    userInfoData.back != ''
                "
                @click="uploadIdCard"
                >查看证件</span
              >
              <span
                v-if="
                  userInfoData.front == null ||
                    userInfoData.front == 'undefined' ||
                    userInfoData.front == '' ||
                    userInfoData.back == null ||
                    userInfoData.back == 'undefined' ||
                    userInfoData.back == ''
                "
                @click="uploadIdCard"
                >上传证件</span
              >
            </template>
            <template v-if="userInfoData.papersType != '1'">
              <span
                v-if="
                  userInfoData.front != null &&
                    userInfoData.front != 'undefined' &&
                    userInfoData.front != null
                "
                @click="uploadIdCard"
                >查看证件</span
              >
              <span
                v-if="
                  userInfoData.front == null ||
                    userInfoData.front == 'undefined' ||
                    userInfoData.front == null
                "
                @click="uploadIdCard"
                >上传证件</span
              >
            </template>
          </van-cell>

          <van-cell class="item" title="认证状态">
            <span v-if="userInfoData.certificationStatus == 'UNVERIFIED'"
              >未认证</span
            >
            <span
              class="text_red"
              v-if="
                userInfoData.certificationStatus == 'AUTHENTICATION_FAILURE'
              "
              >认证失败</span
            >
            <span v-if="userInfoData.certificationStatus == 'AUTHENTICATIONOK'"
              >已认证</span
            >
          </van-cell>
          <van-cell class="item" title="接单意向" is-link @click="editResume">
            <span
              class="text_theme"
              v-if="userInfoData.jobMemo == null || userInfoData.jobMemo == ''"
              >添加</span
            >
            <span
              class="text_theme"
              v-if="userInfoData.jobMemo != null && userInfoData.jobMemo != ''"
              >查看</span
            >
          </van-cell>
          <van-cell
            v-if="specialDeduction"
            class="item"
            title="预缴税额扣除项"
            is-link
            @click="toPrivacy('/prepaid')"
          ></van-cell>
          <van-cell
            class="item"
            title="隐私政策"
            is-link
            @click="toPrivacy('/privacy')"
          ></van-cell>
        </div>
      </div>
    </div>

    <van-popup v-model="showTax" position="bottom" round>
      <div class="popup-content">
        <div class="popup-header">
          <span>预扣预缴个税</span>
          <span class="close-btn" @click="showTax = false">X</span>
        </div>
        <div class="popup-body">
          <p>外派公司：{{ taxInfo.ecompanyName }}</p>
          <p>用工类型：{{ taxInfo.jobCategoryName }}</p>
        </div>
        <div class=" com-table">
          <van-row class="row-header">
            <van-col span="12">服务商</van-col>
            <van-col span="5">个税承担</van-col>
            <van-col span="7">减除项</van-col>
          </van-row>
          <van-row
            class="row-content"
            v-for="item in taxInfo.companyList"
            :key="'companyList' + item.id"
          >
            <van-col span="12">{{ item.ocompanyName }}</van-col>
            <van-col span="5">{{
              getName(item.prepayTaxAssume, '0', item.limitTaxStandard)
            }}</van-col>
            <van-col span="7"> {{ getName(item.deductExpenses, '1') }}</van-col>
          </van-row>
        </div>
      </div>
    </van-popup>
    <div class="card_box">
      <div class="card_header van-hairline--bottom">外派公司</div>
      <div class="card_content expatriate-company">
        <template v-if="expatriate_company.length">
          <van-row
            type="flex"
            align="center"
            v-for="item in expatriate_company"
            :key="item.ecompanyId"
          >
            <van-col span="15">{{ item.ecompanyName }}</van-col>
            <van-col span="5">
              <span
                class="icon_status tobe"
                v-if="item.status == 'wsign'"
                @click="toContractList"
                >待签署</span
              >
              <span
                class="icon_status yes"
                v-else-if="item.status == 'signed'"
                @click="toContractList"
                >已签署</span
              >
              <span
                class="icon_status end"
                v-else-if="item.status == 'termination'"
                @click="toContractList"
                >已终止</span
              >
              <span
                class="icon_status yes"
                v-else-if="item.status == 'unifiedSignSuccess'"
                @click="toContractList"
                >企业统签</span
              >
              <span class="icon_status no" v-else @click="toContractList"
                >未签署</span
              ></van-col
            >
            <van-col span="4">
              <van-button
                color="#7232dd"
                plain
                size="mini"
                @click="seeTax(item.ecompanyId)"
                >查看个税</van-button
              ></van-col
            >
          </van-row>
        </template>
      </div>
    </div>
    <!-- <div class="card_box">
      <div class="card_header van-hairline--bottom">公司信息</div>
      <div class="card_content">
        <section class="company">
          <div class="item">
            <label>所属公司</label>
            <div class="value">
              <template v-if="outsourcing_company.length">
                <p
                  v-for="item in outsourcing_company"
                  :key="item"
                  class="van-hairline--bottom"
                >
                  {{ item }}
                </p>
              </template>
              <template v-else>
                <p>无</p>
              </template>
            </div>
          </div>
          <div class="item">
            <label>外派公司</label>
            <div class="value">
              <template v-if="expatriate_company.length">
                <div
                  class="line van-hairline--bottom"
                  v-for="item in expatriate_company"
                  :key="item.ecompanyName"
                >
                  <span
                    class="icon_status tobe"
                    v-if="item.status == 'wsign'"
                    @click="toContractList"
                    >待签署</span
                  >
                  <span
                    class="icon_status yes"
                    v-else-if="item.status == 'signed'"
                    @click="toContractList"
                    >已签署</span
                  >
                  <span
                    class="icon_status end"
                    v-else-if="item.status == 'termination'"
                    @click="toContractList"
                    >已终止</span
                  >
                  <span
                    class="icon_status yes"
                    v-else-if="item.status == 'unifiedSignSuccess'"
                    @click="toContractList"
                    >企业统签</span
                  >
                  <span class="icon_status no" v-else @click="toContractList"
                    >未签署</span
                  >
                  <p>{{ item.ecompanyName }}</p>
                </div>
              </template>
              <p v-else>无</p>
            </div>
          </div>
        </section>
      </div>
    </div> -->
  </div>
</template>
<script>
import { Image, Cell, CellGroup, Button, Icon, Row, Col, Popup } from 'vant'
import jobHeaderSimple from '@/components/header/header.vue'
import api from '@/api/list'
import { getEOCompanyList } from '@/api/ocompany/request'
import { mapGetters } from 'vuex'
import { getToken } from '@/utils/auth'
export default {
  components: {
    [Image.name]: Image,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Button.name]: Button,
    [Icon.name]: Icon,
    [Row.name]: Row,
    [Col.name]: Col,
    [Popup.name]: Popup,
    jobHeaderSimple,
  },
  data() {
    return {
      specialDeduction: true, //是否允许专项扣除
      showTax: false,
      papersTypeOptions: [],
      user: {},
      outsourcing_company: [],
      expatriate_company: [],
      taxInfo: {
        companyList: [],
        ecompanyName: '',
        jobCategoryName: '',
      },

      userInfoData: {}, //用户信息
    }
  },
  computed: {
    ...mapGetters(['userInfo', 'mobileDefaultAvatar']),
  },
  async created() {
    this.userInfoData = await this.getActiveUserAllInfoInit()
    this.getPaperType()
    this.initCompanyInfos()
  },
  methods: {
    getName(data, type, limit) {
      let str = ''
      if (type == '0') {
        if (data === 0) {
          str = '个人'
          if (limit && limit == 1) {
            str = '个人/服务商'
          }
        }
        if (data === 1) {
          str = '企业'
        }
        if (str == '') {
          str = '无预缴'
        }
      } else {
        let arr = data ? data.split(',') : []
        arr.map((item) => {
          if (parseInt(item) == 0) {
            if (str.length === 0) {
              str += '固定'
            } else {
              str += '/固定'
            }
          }
          if (parseInt(item) == 1) {
            if (str.length === 1) {
              str += '专项附加'
            } else {
              str += '/专项附加'
            }
          }
        })
        if (str == '--') {
          str = '无预缴'
        }
      }

      return str
    },
    //查看个税
    seeTax(ecompanyId) {
      this.showTax = true
      //根据id查询个税
      getEOCompanyList({ ecompanyId: ecompanyId }).then((res) => {
        if (res.data.status == '200') {
          this.taxInfo.companyList = res.data.data.ecompanyCostRules
          this.taxInfo.ecompanyName = res.data.data.ecompanyName
          this.taxInfo.jobCategoryName = res.data.data.jobCategoryName
        }
      })
    },
    getActiveUserAllInfoInit() {
      return new Promise((resolve, reject) => {
        if (this.userInfo && this.userInfo.id) {
          resolve(this.userInfo)
        } else {
          if (getToken()) {
            api
              .getActiveUserAllInfo()
              .then((res) => {
                if (res.data.status == '200') {
                  let user = res.data.data
                  this.$store.commit('SET_USER_INFO', user)
                  resolve(user)
                }
              })
              .catch((error) => {
                reject(error)
              })
          } else {
            resolve('')
          }
        }
      })
    },
    //证件照片相关方法
    uploadIdCard() {
      let that = this
      let frontUrl = ''
      let backUrl = ''
      if (
        that.userInfoData.front != null &&
        that.userInfoData.front != '' &&
        that.userInfoData.front != undefined
      ) {
        frontUrl = process.env.VUE_APP_FILE_PATH + that.userInfoData.front
      }
      if (
        that.userInfoData.back != null &&
        that.userInfoData.back != '' &&
        that.userInfoData.back != undefined
      ) {
        backUrl = process.env.VUE_APP_FILE_PATH + that.userInfoData.back
      }
      this.$router.push({
        path: 'editPapers',
        query: {
          papersType: that.userInfoData.papersType,
          username: that.userInfoData.username,
          frontUrl: frontUrl,
          backUrl: backUrl,
        },
      })
    },

    getPaperType() {
      api.getDataDictList({ group: 'papersType' }).then((response) => {
        this.papersTypeOptions = response.data.data
      })
    },
    toContractList() {
      this.$router.push({ path: '/contractList' })
    },
    resetTel() {
      this.$router.push({
        path: '/resetTel',
      })
    },

    editResume() {
      this.$router.push({
        path: '/editResume',
      })
    },
    initCompanyInfos() {
      api.getEOCompany().then((res) => {
        if (res.data.status == '200') {
          this.outsourcing_company = res.data.data.ocompany
          this.expatriate_company = res.data.data.ecompany
          this.specialDeduction = res.data.data.isSpecialDeduction
        }
      })
    },
    toPrivacy(path) {
      this.$router.push({
        path: path,
      })
    },
  },
  filters: {
    desensitization: (value) => {
      if (value && value !== '') {
        return `${value.substring(0, 4)}****${value.substring(14, 18)}`
      }
    },
  },
}
</script>

<style lang="less" scoped>
.popup-content {
  font-size: 14px;
  padding: 10px;
  .popup-body {
    padding: 6px 10px 4px;
    line-height: 22px;
  }

  .popup-header {
    font-size: 16px;
    position: relative;
    text-align: center;
    .close-btn {
      cursor: pointer;
      width: 24px;
      height: 24px;
      border-radius: 50%;
      border: 1px solid #666;
      line-height: 24px;
      text-align: center;
      position: absolute;
      right: 0;
    }
  }
}
.userCenter {
  .icon_status {
    font-size: 10px;
    color: #fff;
    padding: 3px 8px;
    border-radius: 8px;
    &.yes {
      background-color: #8493fa;
    }
    &.no {
      background-color: #bbbbbb;
    }
    &.tobe {
      background-color: #f3a871;
    }
    &.end {
      background-color: #f38c6c;
    }
  }
  .com-table {
    padding: 4px 4px 16px;
    box-sizing: border-box;
    font-size: 14px;
  }
  .row-header {
    .van-col {
      background-color: #6e80ef;
      color: #fff;
      text-align: center;
      height: 28px;
      line-height: 28px;
    }
  }
  .row-content {
    display: flex;
    align-items: center;
    font-size: 13px;
    .van-col {
      text-align: center;

      padding: 4px 0;
      height: 100%;
    }
  }
  .card_box {
    margin: 8px 12px;
    background: #fff;
    border-radius: 6px;
    .card_header {
      font-size: 14px;
      padding: 14px;
      font-weight: 600;
    }
    .expatriate-company {
      font-size: 13px;
      padding: 0 10px;
      /deep/.van-row {
        padding: 8px 0;
      }
    }
    .card_content {
      padding-bottom: 10px;
      .baseInfo {
        .item {
          color: #333;
          &.item_head {
            line-height: 0;
            /deep/ .van-cell__title {
              line-height: 30px;
            }
          }

          .van-icon-arrow {
            color: #ddd;
          }

          .van-cell__value {
            color: #333;
          }
          .van-cell__right-icon {
            margin-left: 0;
          }
        }
      }
    }
  }

  .text_theme {
    color: #6c7ef3;
  }

  .text_red {
    color: #f44;
  }
}

.company {
  background: #fff;
  padding: 6px 16px;
  line-height: 20px;
  .item {
    position: relative;
    overflow: hidden;
    font-size: 13px;
    margin-bottom: 6px;
    label {
      display: block;
      position: absolute;
      left: 0;
      top: 0;
      width: 70px;

      padding: 6px 0;
    }
    .value {
      display: block;
      .line {
        overflow: hidden;
        p {
          width: 50%;
        }
      }
      p {
        padding: 6px 10px 6px 70px;
      }

      .icon_status {
        font-size: 0.24rem;
        color: #fff;
        padding: 0 0.1333rem;
        border-radius: 0.32rem;
        margin-left: 6px;
        margin-top: 6px;
        float: right;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        &.yes {
          background-color: #8493fa;
        }
        &.no {
          background-color: #bbbbbb;
        }
        &.tobe {
          background-color: #f3a871;
        }
        &.end {
          background-color: #f38c6c;
        }
      }
    }
  }
}
</style>
